import React from 'react';

import {TREND} from "../../app/consts";
import {DownTrend} from "./down-trend";
import {UpTrend} from "./up-trend";

export const Trend = ({trend, shouldRenderTrend}) => {
  return (
    shouldRenderTrend ? <>
      {
        trend === TREND.down ? <DownTrend/> : null
      }
      {
        trend === TREND.up ? <UpTrend/> : null
      }
    </> : null
  )
}
